var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    alt: "Accessibility Control Panel Icon",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#0A76DB",
    cx: 12,
    cy: 12,
    r: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M12,1c6.065,0,11,4.935,11,11s-4.935,11-11,11S1,18.065,1,12S5.935,1,12,1 M12,0C5.373,0,0,5.373,0,12 s5.373,12,12,12s12-5.373,12-12S18.627,0,12,0L12,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M12.5,11.367l4.686-1.874l-0.371-0.929L12.5,10.29V8.144c1.141-0.232,2-1.24,2-2.45 c0-1.381-1.119-2.5-2.5-2.5s-2.5,1.119-2.5,2.5c0,1.209,0.859,2.218,2,2.45v2.146L7.186,8.564L6.814,9.493l4.686,1.874v3.385 l-3.771,4.743l0.783,0.623L12,15.731l3.487,4.386l0.783-0.623L12.5,14.752V11.367z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibility);
export default __webpack_public_path__ + "static/media/Accessibility.860352b2.svg";
export { ForwardRef as ReactComponent };